import "./views/desktop/shared/_marketingSpotlight.js";
import "./views/home/partials/desktop/_theatersModule.js";
import "./views/home/partials/desktop/_theatersModuleCardsPlaceholder.js";
import "./views/fd-pkgs/@fd-assets/carousel/shared/partials/_movieCarousel.js";
import "./views/home/partials/desktop/_errorMessage.js";
import "./views/home/partials/desktop/_noShowtimes.js";
import "./views/fd-pkgs/fd-location/partials/_locationDropdown.js";